import HIHButton from './HIHButton';
import CoffeeSticker from './CoffeeSticker';
import TripleLines from './TripleLines';
import { useBreakpoints } from '@/utils/useBreakpoints';
import { EMPTY_EVENTS_TEXT, EMPTY_GUIDES_TEXT } from '@/shared/constants';
import styles from './EmptyList.module.scss';

interface EmptyListProps {
  description: string;
  currentTab?: number;
  buttonText: string;
  setCurrentTab?: (value: number) => void;
  buttonHref?: string;
}

export const EmptyList = ({
  description,
  currentTab,
  buttonText,
  setCurrentTab,
  buttonHref,
}: EmptyListProps) => {
  const { isLg } = useBreakpoints();

  const handleTabSwitch = () => {
    if (setCurrentTab && currentTab !== undefined) {
      setCurrentTab(currentTab === 0 ? 1 : 0);
    }
  };

  return (
    <div className={styles.emptyList}>
      <div className={styles.bgBlobDesktop}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="436"
          height="417"
          viewBox="0 0 449 401"
          fill="none"
          aria-hidden="true"
          focusable="false"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M188.684 35.2716C248.713 16.4692 314.506 -20.3664 366.849 14.5213C418.617 49.0254 404.213 124.088 414.095 185.512C425.171 254.358 477.678 336.842 426.288 383.975C374.927 431.08 298.753 364.377 229.755 354.58C165.157 345.407 89.287 378.125 45.3574 329.885C-3.78708 275.918 -12.6963 189.037 19.2347 123.402C48.5373 63.169 124.763 55.2928 188.684 35.2716Z"
            fill="#EDEDED"
          />
        </svg>
      </div>
      <div className={styles.bgBlobMobile}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="239"
          height="229"
          viewBox="0 0 239 229"
          fill="none"
          aria-hidden="true"
          focusable="false"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M134.129 2.64958C168.533 3.69279 209.15 -3.55294 229.955 23.868C250.53 50.9873 229.625 87.2093 223.72 120.735C217.101 158.312 229.456 210.367 194.438 225.518C159.441 240.661 132.022 192.52 98.1088 175.083C66.3592 158.759 21.2707 162.069 7.21045 129.254C-8.51896 92.544 2.45323 46.0326 30.7289 17.8269C56.6771 -8.05706 97.4953 1.53874 134.129 2.64958Z"
            fill="#EDEDED"
          />
        </svg>
      </div>

      <div className={styles.content}>
        <div className={styles.headline}>
          <TripleLines variant="topLeft" isLargeSize={isLg}>
            Hier
          </TripleLines>{' '}
          gibt&apos;s noch nichts zu{' '}
          <CoffeeSticker className={styles.coffeeStickerOverflow}>kieken</CoffeeSticker>
        </div>

        <div className={styles.body}>
          <div className={styles.description}>{description}</div>

          <div className={styles.buttonWrapper}>
            <HIHButton
              title={buttonText}
              onClick={setCurrentTab ? handleTabSwitch : undefined}
              link={buttonHref}
              className={styles.buttonInline}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
